<template>
    <div>
        <h4>Deltek Project Summary Import</h4>
        <file-upload-form
            value=""
            :accepts="upload_accepts('deltek_summary')"
            :uploading="!!uploading.deltek_summary"
            :uploaded="uploaded.deltek_summary||0"
            :editable="true"
            @upload="upload_file_list('deltek_summary', $event)"
        />

        <h4>Employee Benefits Import</h4>
        <file-upload-form
            value=""
            :accepts="upload_accepts('benefits')"
            :uploading="!!uploading.benefits"
            :uploaded="uploaded.benefits||0"
            :editable="true"
            @upload="upload_file_list('benefits', $event)"
        />

        <base-button
            :block="true"
            class="uk-margin-large-top"
            @click.prevent="creating_newsletter=true"
        >
            Lumen Launchpad
        </base-button>
        <div
            v-if="!!newsletter_notification && !!newsletter_notification.send_at"
            class="uk-text-small uk-text-center uk-margin-small-top"
        >
            Scheduled for {{ newsletter_notification.send_at || nibnut.date("D MMMM YYYY") }}
            <div>
                <base-button
                    flavor="link"
                    size="small"
                    class="uk-margin-small-right"
                    @click.stop.prevent="reset_newsletter_notification"
                >
                    <open-icon glyph="close" /> Cancel
                </base-button>
                <base-button
                    flavor="link"
                    size="small"
                    class="uk-margin-small-left"
                    @click.stop.prevent="send_newsletter_notification_now"
                >
                    <open-icon glyph="send" /> Send Now
                </base-button>
            </div>
        </div>

        <newsletter-dialog
            :show.sync="creating_newsletter"
            @close="creating_newsletter=false"
        />
    </div>
</template>

<script type="text/javascript">
import dashboard_card from "./dashboard_card"
import profile_utilities from "../../mixins/ProfileUtilities"
import handles_uploads from "../../mixins/HandlesUploads"
import handles_newsletter_notification from "../../mixins/HandlesNewsletterNotification"

import FileUploadForm from "../../ui/FileUploadForm"
import BaseButton from "../../ui/BaseButton"
import OpenIcon from "../../ui/OpenIcon"
import NewsletterDialog from "../../dialogs/Newsletter"

export default {
    mixins: [dashboard_card, profile_utilities, handles_uploads, handles_newsletter_notification],
    components: {
        FileUploadForm,
        BaseButton,
        OpenIcon,
        NewsletterDialog
    },
    mounted () {
        this.load_data()
    },
    watch: {
        profile_id: "load_data",
        $route: "load_data"
    },
    methods: {
        load_data () {
            if(this.profile_id) this.load_newsletter_notification()
        },
        upload_accepts (name, filename = null) {
            if(filename) return !!filename.match(/\.(csv|txt)$/i)
            return ".csv,.txt,text/*"
        },
        upload_data (name) {
            if(name === "deltek_summary") return { entity: "financial" }
            return { entity: "user" }
        },
        upload_attach_error (name, error) {
            if(name === "deltek_summary") this.$error(`Deltek data import error: ${error.message}`)
            else this.$error(`Benefits data import error: ${error.message}`)
        },
        upload_attached (name, data) {
            if(!!data && !!data.success) this.$success(data.success)
            if(name === "deltek_summary") this.$success("Deltek data received. It will be imported shortly.")
            else this.$success("Benefits data received. It will be imported shortly.")
        },
        send_newsletter_notification_now () {
            const newsletter_notification = this.newsletter_notification
            if(newsletter_notification.id) {
                newsletter_notification.send_at = ""
                this.send_newsletter_notification()
            }
        }
    },
    data () {
        return {
            creating_newsletter: false,
            attach_action: "import"
        }
    }
}
</script>
